/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5502e161&lang=scss"

const __exports__ = script;

export default __exports__